import { openFrameAsset } from '../../../Maker/F/DecorationIcon/event.js';
import { NewMakerCvObjectCvImageF } from '../../../NewMaker/CvObject/CvImage/F/Function/module/NewMakerCvObjectCvImageF.js';

export const handleOpenFrameAsset = async () => {
  const image = await openFrameAsset();
  if (image) {
    await NewMakerCvObjectCvImageF.addCvImageToMpMaker(image);
  }
};
